/**
 * Created by tomnotcat on 2023/02/21.
 */
import AppConfig from "../config/AppConfig";
import DefaultService from "../services/screens/studyletter/DefaultService";
import DebugLogger from "./DebugLogger";
import EventEmitter from "./EventEmitter";
import StorageEngine from "./StorageEngine";
import * as Helper from "./Helper";
import _ from "lodash";

class LetterInfo {
    constructor(id, state, score) {
        this.id = id;
        this.state = state;
        this.score = score;
    }
};

class LetterStateManager {
    constructor() {
        this._events = new EventEmitter();
        this._pendingLoad = false;
        this._loadTimer = undefined;
        this._letters = new Map();
        this._passingScore = 80;
        this._pendingUpdateTexts = [];
        this._pendingUpdateMap = new Map();
        this._updateViewed = this._updateViewed.bind(this);
        this._disabled = true;
    }

    get events() {
        return this._events;
    }

    letterState(id) {
        if (!AppConfig.ENABLE_LEARN_FUNCTION) {
            // NOTE: 未开启学习功能, 不显示字状态
            return LetterStateManager.StateNotSee;
        }

        const item = this._letters.get(id);
        if (item) {
            switch (item.state) {
            case LetterStateManager.StateViewed:
            case LetterStateManager.StateLearned:
            case LetterStateManager.StateFinished:
                return item.state;

            case LetterStateManager.StatePracticed:
            case LetterStateManager.StatePassed:
                if (item.score >= this._passingScore) {
                    return LetterStateManager.StatePassed;
                }
                return LetterStateManager.StatePracticed;

            default:
                break;
            }
        }
        return LetterStateManager.StateNotSee;
    }

    stateColor(state) {
        switch (state) {
        case LetterStateManager.StateViewed:
            return '#0058ff';

        case LetterStateManager.StateLearned:
            return '#0058ff';
            //return '#6fc8ff';

        case LetterStateManager.StatePracticed:
            return '#ffb007';

        case LetterStateManager.StatePassed:
        case LetterStateManager.StateFinished:
            return '#2cce48';

        default:
            break;
        }
        return undefined;
    }

    letterColor(id) {
        let state = this.letterState(id);
        return this.stateColor(state);
    }

    _setData(data) {
        this._letters.clear();
        this.updateData(data);
    }

    updateData(data, updatedState = false) {
        const letters = data.split(';');
        let changed = false;
        for (let i = 0; i < letters.length; ++i) {
            let items = letters[i].split(':');
            if (items.length === 3) {
                let id = items[0];
                let state = parseInt(items[1]);
                let score = parseInt(items[2]);
                this._letters.set(id, new LetterInfo(id, state, score));
                changed = true;
            }
        }

        if (changed) {
            if(updatedState){
                this._events.emit("updatedState");
            }else{
                this._events.emit("updated");
            }
        }
    }

    _updateViewed() {
        if (this._pendingUpdateTexts.length < 1) {
            return;
        }

        const texts = this._pendingUpdateTexts;
        this._pendingUpdateTexts = [];
        this._pendingUpdateMap.clear();
        this._updateViewedTimer = undefined;

        DefaultService.updateViewed(
            {letters: texts},
            response => {
                this._passingScore = response.passingScore;
                this.updateData(response.data);
            },
            error => {
                console.warn('updateViewed error, ', error);
            }
        );
    }

    updateViewed(s) {
        if (this._disabled) {
            return;
        }

        if (!AppConfig.ENABLE_LEARN_FUNCTION) {
            // NOTE: 未开启学习功能, 不更新字状态
            return;
        }

        if (this._pendingUpdateMap.get(s)) {
            return;
        }

        const texts = s.split('');
        for (let i = 0; i < texts.length; ++i) {
            const info = this._letters.get(texts[i]);
            if (info && info.state >= LetterStateManager.StateViewed) {
                continue;
            }

            if (this._pendingUpdateMap.get(texts[i])) {
                continue;
            }

            this._pendingUpdateMap.set(texts[i], 1);
            this._pendingUpdateTexts.push(texts[i]);
        }

        this._pendingUpdateMap.set(s, 1);
        if (this._pendingUpdateTexts.length > 0) {
            if (!this._updateViewedTimer) {
                this._updateViewedTimer = setTimeout(this._updateViewed, 1000);
            }
        }
    }

    loadFromServer() {
        if (this._pendingLoad) {
            return;
        }

        if (this._loadTimer) {
            return;
        }

        this._pendingLoad = true;
        DefaultService.loadLetterStates(
            response => {
                this._pendingLoad = false;
                if (this._loadTimer) {
                    clearTimeout(this._loadTimer);
                    this._loadTimer = undefined;
                }

                this._passingScore = response.passingScore;
                this._setData(response.data);
            },
            error => {
                console.warn('loadLetterStates error, retry later, ', error);
                this._pendingLoad = false;
                if (!this._loadTimer) {
                    this._loadTimer = setTimeout(() => {
                        this._loadTimer = undefined;
                        this.loadFromServer();
                    }, 1000);
                }
            }
        );
    }
}

LetterStateManager.StateNotSee = 0;
LetterStateManager.StateViewed = 1;
LetterStateManager.StateLearned = 2;
LetterStateManager.StatePracticed = 3;
LetterStateManager.StatePassed = 4;
LetterStateManager.StateFinished = 5;

var g_letterStateManager = null;

LetterStateManager.instance = function() {
    if (!g_letterStateManager) {
        g_letterStateManager = new LetterStateManager();
    }
    return g_letterStateManager;
}

export default LetterStateManager;
